function setInputFilter(els, inputFIlter, errMessages) {

    ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop", "focusout"].forEach(function (event) {
        
        if(!els) return;

        if (els.length > 0) {
            els.forEach(function (el) {

                el.addEventListener(event, function (e) {
                    if (inputFIlter(this.value)) {
                        if (["keydown","mousedown","focusout"].indexOf(e.type) >= 0) {
                            this.classList.remove("error");
                            this.setCustomValidity("");
                        }

                        this.oldValue = this.value;
                        this.oldSelectionStart = this.selectionStart;
                        this.oldSelectionEnd = this.selectionEnd;
                    } else if (this.hasOwnProperty("oldValue")) {
                        this.classList.add("error");
                        this.setCustomValidity(errMessages);
                        this.reportValidity();
                        this.value = this.oldValue;
                        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
                    } else {
                        this.value = "";
                    }
                })
            })
        }
    });
}

let inputName = "[data-form='fullname']";
let inputIdCard = "[data-form='idcard']";
let inputPhone = "[data-form='phone']";
let inputEmail = "[data-form='email']";

setInputFilter(document.querySelectorAll(inputIdCard), function (value) {
    return /^-?\d*$/.test(value);
}, "Silakan ketik Nomor KTP yang benar");

setInputFilter(document.querySelectorAll(inputName), function (value) {
    return /^[a-z ]*$/i.test(value);
}, "Silakan ketik Nama Lengkap yang benar");

setInputFilter(document.querySelectorAll(inputPhone), function (value) {
    return /^-?\d*$/.test(value);
}, "Nomor Handphone harus diisi");